// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3wjoJ","container":"styles_container__29PU2","title":"styles_title__3BvU0","wrapper":"styles_wrapper__2D-01","answer":"styles_answer__1Dpet"};